import { HStack } from '@genial/components';

import { IconCustomerListProps } from '../../../models';
import { CustomerNameIcon } from '../CustomerNameIcon';

export const IconCustomerList = ({ icons, isTooltip }: IconCustomerListProps) => {
  return (
    <HStack space={'4px'}>
      {icons.map((icon) => (
        <CustomerNameIcon name={icon} key={icon} isTooltip={isTooltip} />
      ))}
    </HStack>
  );
};
